/**
 * DevExtreme (ui/scroll_view.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
module.exports = require("./scroll_view/ui.scroll_view");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/scroll_view.js
// module id = ../../../../devextreme/ui/scroll_view.js
// module chunks = common